import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
    fill?: string;
    stroke?: string;
}

const GiftFinderIcon: React.FC<Props> = ({ fill = "none", stroke = "white", ...props }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M4 11V15C4 18.2998 4 19.9497 5.02513 20.9749C6.05025 22 7.70017 22 11 22M20 15V11"
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3 9C3 8.25231 3 7.87846 3.20096 7.6C3.33261 7.41758 3.52197 7.26609 3.75 7.16077C4.09808 7 4.56538 7 5.5 7H18.5C19.4346 7 19.9019 7 20.25 7.16077C20.478 7.26609 20.6674 7.41758 20.799 7.6C21 7.87846 21 8.25231 21 9C21 9.74769 21 10.1215 20.799 10.4C20.6674 10.5824 20.478 10.7339 20.25 10.8392C19.9019 11 19.4346 11 18.5 11H5.5C4.56538 11 4.09808 11 3.75 10.8392C3.52197 10.7339 3.33261 10.5824 3.20096 10.4C3 10.1215 3 9.74769 3 9Z"
                stroke={stroke}
                strokeLinejoin="round"
            />
            <path
                d="M6 3.78571C6 2.79949 6.79949 2 7.78571 2H8.14286C10.2731 2 12 3.7269 12 5.85714V7H9.21429C7.43908 7 6 5.56091 6 3.78571Z"
                stroke={stroke}
                strokeLinejoin="round"
            />
            <path
                d="M18 3.78571C18 2.79949 17.2005 2 16.2143 2H15.8571C13.7269 2 12 3.7269 12 5.85714V7H14.7857C16.5609 7 18 5.56091 18 3.78571Z"
                stroke={stroke}
                strokeLinejoin="round"
            />
            <path
                d="M18.0833 20.0833L19.75 21.75"
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.9167 17.5833C18.9167 15.7424 17.4243 14.25 15.5833 14.25C13.7424 14.25 12.25 15.7424 12.25 17.5833C12.25 19.4243 13.7424 20.9167 15.5833 20.9167C17.4243 20.9167 18.9167 19.4243 18.9167 17.5833Z"
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default GiftFinderIcon;
